import { Component, ViewChild, NgZone } from '@angular/core';
import { IonModal,IonSlides } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { ActionSheetController, NavController } from '@ionic/angular';
import { Router } from '@angular/router';
import { HomeService } from './home.service';


@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  
})
export class HomePage {
  @ViewChild(IonModal) modal: IonModal;

  message = 'This modal example uses triggers to automatically open a modal when the button is clicked.';
  name: string;
  txt: any = "";

  ListAllDashBoard: any;

  cnt1: any = 0;
  cnt2: any = 0;
  cnt3: any = 0;

  Session_AppUserID: any = 0;

  Score: any=0;
  Wallet: any=0;
  Discount:any=0;
  ResultScoreWallet: any;
  ResultLastDateOfGame:any;
  
  Session_Name:any;
  Session_LastName:any;

  AdsImages = [
    "../../assets/images/portfolio-06.jpg",
    "../../assets/images/portfolio-05.jpg",
    "../../assets/images/portfolio-04.jpg"
  ];

  slideOpts = {
    zoom: false
  };

  @ViewChild("mySlider") slides: IonSlides;

  constructor(private home_serv: HomeService, public actionSheetController: ActionSheetController, private router: Router, public zone: NgZone) {
    this.Session_AppUserID = localStorage.getItem('Session_AppUserID');
    this.ShowPage();
  }

  ngOnInit() {
    // this.Session_AppUserID = localStorage.getItem('Session_AppUserID');
  }

  slidesDidLoad() {
    this.slides.startAutoplay();
  }

  ShowPage() {

    this.home_serv.ShowPage(localStorage.getItem('Session_AppUserID')).subscribe(
      res => {
        this.zone.run(() => {
          this.ListAllDashBoard = res;
          console.log("res", res);

          this.cnt1 = res['cnt1'];
          this.cnt2 = res['cnt2'];
          this.cnt3 = res['cnt3'];


          this.Score = res['resultScore'];
          this.Wallet = res['resultWallet'];
          this.ResultScoreWallet = res['resultScoreWallet'];
          this.ResultLastDateOfGame = res['resultLastDateOfGame'];
          this.Discount=res['resultDis'];

        });

      }, err => {
        console.log("ERRRORRRR2");
        console.log(JSON.stringify(err));
      });
  }



  doRefresh(event) {
    console.log('Begin async operation');
    this.ShowPage();

    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  


}